// TAX-CATEGORY-PREMIUM-SELECT-001 — presentation-only replacement for the native
// Tax Category <select>. Values/labels are unchanged; emits the same string|null.
import React from 'react';
import { FileText, Landmark, Building2, GraduationCap, Home, Building, Layers, Warehouse } from 'lucide-react';
import PremiumListbox from './PremiumListbox';

export const TAX_CATEGORY_OPTIONS = [
  { value: '', label: '— Not set (use jurisdiction type) —', Icon: FileText, tone: 'tcp-tile-indigo' },
  { value: 'county', label: 'County', Icon: Landmark, tone: 'tcp-tile-blue' },
  { value: 'city', label: 'City', Icon: Building2, tone: 'tcp-tile-violet' },
  { value: 'school', label: 'School', Icon: GraduationCap, tone: 'tcp-tile-green' },
  { value: 'town', label: 'Town', Icon: Home, tone: 'tcp-tile-amber' },
  { value: 'boro', label: 'Boro', Icon: Building, tone: 'tcp-tile-blue' },
  { value: 'boro/county', label: 'Boro / County', Icon: Layers, tone: 'tcp-tile-indigo' },
  { value: 'county/town', label: 'County / Town', Icon: Layers, tone: 'tcp-tile-indigo' },
  { value: 'county/city', label: 'County / City', Icon: Layers, tone: 'tcp-tile-indigo' },
  { value: 'city/school', label: 'City / School', Icon: Layers, tone: 'tcp-tile-indigo' },
  { value: 'county/city/school', label: 'County / City / School', Icon: Layers, tone: 'tcp-tile-indigo' },
  // TAX-CATEGORY-PREMIUM-SELECT-002 — standard bill types added Nov 2026 (free-string field; downstream narrative lowercases the value)
  { value: 'county/town/school', label: 'County / Town / School', Icon: Layers, tone: 'tcp-tile-violet' },
  { value: 'village', label: 'Village', Icon: Warehouse, tone: 'tcp-tile-green' },
];

const TaxCategorySelect = ({ value, onChange, disabled = false, testId = 'jm-tax-category-select' }) => (
  <PremiumListbox
    value={value || ''}
    options={TAX_CATEGORY_OPTIONS}
    onChange={(v) => onChange(v || null)}
    disabled={disabled}
    ariaLabel="Tax Category (bill type)"
    testId={testId}
    searchable
    searchPlaceholder="Search tax category…"
  />
);

export default TaxCategorySelect;
